import React from 'react';
import './GoogleReviewCard.css';

const GoogleReviewCard = ({ review }) => {
  return (
    <div className="gcard">
      <div className="gcard-top">
        <img
          className="gcard-avatar-img"
          src={review.image}
          alt={review.name}
        />
        <div>
          <div className="gcard-nome">{review.name}</div>
          <div className="gcard-setor">{review.sector}</div>
        </div>
        <div className="gcard-stars">
          {'★'.repeat(review.rating)}
        </div>
      </div>
      <p className="gcard-comment">{review.comment}</p>
      <div className="gcard-logo">
        no <span className="gG">
          <b>G</b><b>o</b><b>o</b><b>g</b><b>l</b><b>e</b>
        </span>
      </div>
    </div>
  );
};

export default GoogleReviewCard;
